import styled, { css } from 'styled-components';
import { showAnimation } from '../../../../commons/showAnimation';
export var Inner = styled.div.withConfig({
  displayName: "Inner",
  componentId: "sc-nc2y8-0"
})(["display:none;position:absolute;z-index:2;width:100%;min-width:180px;", " ", ""], function (props) {
  return props.open && css(["display:block;"]);
}, showAnimation);